
class UserModel {
    "use strict";

    set(data){
        Object.assign(this, data);
    }
}

export default UserModel;